<!-- 新建/编辑授课班级 -->
<template>
  <div class="editTeacherClass">
    <header class="header">
      <span>新建/编辑授课班级</span>
      <el-button class="fr" @click="$router.go(-1)" style="margin-left:10px;">返回</el-button>
      <el-button type="primary" class="fr" @click="saveSubmit">保存</el-button>
    </header>
    <div>
      <el-form :model="updateCourse" label-width="150">
        <el-row>
          <el-col :span="6">
            <el-form-item label="授课班级">
              <el-input v-model="updateCourse.courseName" placeholder="请输入" style="width:300px;"></el-input>
            </el-form-item>
            <el-form-item label="课程名称">
              <el-input v-model="updateCourse.name" placeholder="请输入" style="width:300px;"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="开课日期">
              <el-date-picker
                v-model="updateCourse.startDate"
                type="date"
                placeholder="选择日期"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
              <!-- <DatePicker type="date" placeholder="请选择" value-format="yyyy-MM-dd" v-model="course.startDate" style="width:80%"></DatePicker> -->
            </el-form-item>
            <el-form-item label="结课日期">
              <el-date-picker
                v-model="updateCourse.endDate"
                type="date"
                placeholder="选择日期"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
              <!-- <el-time-picker v-model="course.endDate" placeholder="请选择"  value-format="yyyy-MM-dd"></el-time-picker> -->
              <!-- <DatePicker type="date" placeholder="请选择" value-format="yyyy-MM-dd" v-model="course.endDate" style="width:80%"></DatePicker> -->
            </el-form-item>
          </el-col>
          <!-- <el-col :span="6">
            <el-form-item label="课程表">
              <el-button @click="calendarVisible = true">设置</el-button>
            </el-form-item>
          </el-col>-->
        </el-row>
      </el-form>
    </div>
    <div class="table-select">
      <p class="title" style="margin-bottom:10px;font-size:14px;font-family:PingFang-SC;">编辑上课学生班级</p>
      <el-row>
        <el-col :span="12" style="padding-right:20px;">
          <el-select
            v-model="gotoClass.type"
            class="fl"
            style="width:100px;"
            @input="searchSchool()"
          >
            <el-option :value="0" label="全部"></el-option>
            <el-option :value="1" label="学院"></el-option>
            <el-option :value="2" label="专业"></el-option>
            <el-option :value="3" label="年级"></el-option>
          </el-select>
          <el-input
            v-model="gotoClass.word"
            placeholder="输入学院、专业、年级、班级"
            class="fl"
            style="width:340px;margin:0 10px"
          >
            <el-button slot="append" icon="el-icon-search" @click="searchSchool"></el-button>
          </el-input>
          <el-button @click="AllRow('add')" class="fl" style="margin-left:10px;">全选</el-button>
          <el-table
            ref="currentRowTable"
            :data="data1"
            tooltip-effect="dark"
            @selection-change="transfer"
          >
            <el-table-column prop="collegeName" label="学院名称"></el-table-column>
            <el-table-column prop="majorName" label="专业名称"></el-table-column>
            <el-table-column prop="gradeName" label="年级"></el-table-column>
            <el-table-column prop="className" label="班级"></el-table-column>
            <el-table-column prop="num" label="人数" width="50"></el-table-column>
            <el-table-column label="操作" width="100">
              <template slot-scope="scope">
                <div>
                  <!-- <el-button type="primary" size="small" @click="addRow(scope.row)">添加</el-button> -->
                  <el-button
                    type="primary"
                    size="mini"
                    @click="addRow(scope.row)"
                    v-if="scope.row.types"
                  >添加</el-button>
                  <el-button disabled type="primary" size="mini" v-else>已添加</el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <div style="text-align: center; margin-top: 10px;">
            <el-pagination
              @current-change="searchSchool"
              class="foot-pager"
              :page-size="10"
              layout="prev, pager, next"
              :total="totals"
              :current-page.sync="gotoClass.startIndex"
            ></el-pagination>
          </div>
        </el-col>
        <el-col :span="12">
          <div style="clear: both; overflow: hidden; margin-bottom: 12px;">
            <el-button type="danger" size="mini" @click="AllRow('del')" class="fr">全部删除</el-button>
          </div>
          <!-- :data="data2" -->
          <el-table
            ref="removerTable"
            :data="data2.slice( (currentPage - 1) * 10, currentPage * 10 )"
            tooltip-effect="dark"
            @selection-change="selectedRemover"
          >
            <el-table-column prop="collegeName" label="学院名称"></el-table-column>
            <el-table-column prop="majorName" label="专业名称"></el-table-column>
            <el-table-column prop="gradeName" label="年级"></el-table-column>
            <el-table-column prop="className" label="班级"></el-table-column>
            <el-table-column prop="num" label="人数" width="50"></el-table-column>
            <el-table-column label="操作" width="80">
              <template slot-scope="scope">
                <div>
                  <el-button type="primary" size="small" @click="delRow(scope.row)">移除</el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <div style="text-align: center; margin-top: 10px;">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleSizeChange"
              :current-page.sync="currentPage"
              :page-size="10"
              layout="prev, pager, next"
              :total="data2.length"
            ></el-pagination>
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- 课程表设置 -->
    <el-dialog title="课程表设置" :visible.sync="calendarVisible" top="2vh" width="1200px">
      <div>
        <span style="padding-right: 20px; font-size: 18px;">课程表</span>
        <el-button size="small">上传Excel批量设置</el-button>
        <el-button size="small">下载样例Excel文档</el-button>
        <el-button size="small" type="danger">清空所有已添加</el-button>
      </div>
      <calendar></calendar>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import calendar from "../../common/calendar";
export default {
  data() {
    return {
      currentPage: 1,
      totals: 0,
      calendarVisible: false,
      loading: false,
      course: {},
      columns: [
        {
          type: "selection",
          width: 60,
          align: "center",
        },
        {
          title: "学院名称",
          key: "academy",
        },
        {
          title: "专业名称",
          key: "professional",
        },
        {
          title: "年级",
          key: "grade",
        },
        {
          title: "班级",
          key: "class",
        },
        {
          title: "人数",
          key: "count",
        },
      ],
      data1: [],
      data2: [],
      gotoClass: {
        showItem: 10,
        pageIndex: 1,
        schoolId: this.$route.query.schoolId,
        type: 0,
        word: "",
      },
      courseType:true,
      updateCourse: {
        classIds: [], // 授课班级
        courseId: 0,
        courseName: "", // 授课名称
        endDate: "", // 结束时间
        name: "", // 课程名称
        schoolId: this.$route.query.schoolId, //高校id
        startDate: "", // 开始时间
        teacherId: this.$route.query.teacherId, // 教师id
      },
    };
  },
  components: { calendar },
  methods: {
    // 分页
    handleSizeChange(val) {
      this.currentPage = val;
    },
    // 编辑初始化
    ngOnInit() {
      const param = {
        courseId: this.$route.query.courseId,
        schoolId: this.$route.query.schoolId,
      };
      if (this.data2.length == 0 && this.courseType) {
        this.courseType = false
        this.$api.allianceSchool.getCourseTeachingClass(param).then((res) => {
          if (res.errCode == 0) {
            this.updateCourse.courseId = res.data.courseId;
            this.updateCourse.courseName = res.data.courseName;
            this.updateCourse.endDate = res.data.endDate;
            this.updateCourse.name = res.data.name;
            this.updateCourse.startDate = res.data.startDate;
            this.data2 = res.data.courseClassVOS || [];
            this.data2.forEach((item, i) => {
              if (this.data1.filter((li) => li.classId == item.classId).length > 0) {
                this.data1.filter((li) => li.classId == item.classId)[0].types = false;
              }
            });
          } else {
            this.$message.error(res.errMsg);
          }
        });
      } else {
        this.data2.forEach((item, i) => {
          if (this.data1.filter((li) => li.classId == item.classId).length > 0) {
            this.data1.filter(
              (li) => li.classId == item.classId
            )[0].types = false;
          }
        });
      }
    },
    // 提交
    saveSubmit() {
      if (this.data2.length > 0) {
        this.updateCourse.classIds = [];
        this.data2.forEach((item, idx) => {
          this.updateCourse.classIds.push(item.classId);
        });
      } else {
        this.$message.error("上课学生班级不能为空");
        return;
      }
      this.$api.allianceSchool.updateCourse(this.updateCourse).then((res) => {
        if (res.errCode == 0) {
           this.$message.success("提交成功!");
          this.$router.go(-1);
        } else {
          this.$message.error(res.errMsg);
        }
      });
    },
    transfer(row) {
      this.data2 = row;
      this.data1 = this.data1.filter((item) => item != row[0]);
    },
    // 移除
    delRow(rows) {
      if (
        this.data1.filter((item) => item.classId == rows.classId).length > 0
      ) {
        this.data1.filter(
          (item) => item.classId == rows.classId
        )[0].types = true;
      }
      this.data2 = this.data2.filter((item) => item.classId != rows.classId);
    },
    addRow(rows) {
      rows.types = false;
      this.data2.push(rows);
    },
    // 批量删除、批量添加
    AllRow(type) {
      if (type == "add") {
        this.data1 = this.data1.map((r) => {
          return {
            ...r,
            types: false,
          };
        });
        // 合并去重最新数据
        let arr = this.data1.concat( this.data2);
        let obj = {};
        let peon = arr.reduce((cur,next) => {
            obj[next.classId] ? "" : obj[next.classId] = true && cur.push(next);
            return cur;
        },[])
        this.data2 = peon;
      } else {
        this.data1 = this.data1.map((r) => {
          return {
            ...r,
            types: true,
          };
        });
        this.data2 = [];
      }
    },
    selectedRemover(row) {
      console.log(row);
    },
    // 上课班级学生
    searchSchool() {
      this.loading = true;
      this.$api.allianceSchool
        .getSchoolClass(this.gotoClass)
        .then((res) => {
          this.loading = false;
          if (res.errCode == 0) {
            // this.data1 = res.data;
            if (res.data.items) {
              this.totals = res.data.totalItems;
              this.data1 = res.data.items.map((r) => {
                return {
                  ...r,
                  types: true,
                };
              });
            } else {
              this.totals = 0;
              this.data1 = [];
            }
            if (this.$route.query.courseId) {
              this.$nextTick(() => {
                this.ngOnInit();
              });
            } else {
              this.data2.forEach((item, i) => {
                this.data1.filter(
                  (li) => li.classId == item.classId
                )[0].types = false;
              });
            }
          } else {
            this.$message.error(res.errMsg);
          }
        })
        .catch((res) => {
          this.loading = false;
        });
    },
  },
  created() {
    this.searchSchool();
  },
};
</script>
<style lang='less' scoped>
.editTeacherClass {
  padding: 20px;
  box-sizing: border-box;
  background: #fff;
  header {
    span {
      font-size:16px;
      font-family:PingFang-SC;
      color:#424346;
    }
  }
}
.table-select {
  border: 1px solid #eeeeee;
  padding: 20px;
  .search {
    margin: 10px 0;
    width: 320px;
  }
  .item {
    padding: 8px 0;
  }
}
</style>